import * as yup from "yup";
import i18next from "i18next";

export const validationSchemaCompany = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
        .max(50),
    // phoneNumber: yup
    //   .string()
    //   .required("Żeby się zarejestrować musisz podać numer telefonu")
    //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
    //   .min(9, "niepoprawny numer telefonu")
    //   .max(9, "niepoprawny numer telefonu"),
    name: yup.string().required(() => i18next.t("auth.validation.companyNameRequired", { ns: "admin" })),
    city: yup.string().required(() => i18next.t("auth.validation.cityRequired", { ns: "admin" })),
    street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
    postalCode: yup
        .string()
        .required(() => i18next.t("auth.validation.postalCodeRequired", { ns: "admin" }))
        .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .min(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .max(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" })),
    bdo: yup
        .string()
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.bdoFormat", { ns: "admin" })),
    taxNumber: yup
        .string()
        .required(() => i18next.t("auth.validation.nipRequired", { ns: "admin" }))
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.nipFormat", { ns: "admin" }))
        .min(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" }))
        .max(10, () => i18next.t("auth.validation.nipFormat", { ns: "admin" })),
    regon: yup
        .string()
        .required(() => i18next.t("auth.validation.regonRequired", { ns: "admin" }))
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.regonFormat", { ns: "admin" }))
        .min(9, () => i18next.t("auth.validation.regonInvalid", { ns: "admin" }))
        .max(14, () => i18next.t("auth.validation.regonInvalid", { ns: "admin" })),
    // accept: yup
    //   .boolean()
    //   .oneOf([true], "W celu rejestracji musiz zakceptować regulamin"),
    multiDepartment: yup.boolean().oneOf([true, false]),
});

export const validationSchemaCompanyNotRequired = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
        .max(50),
    // phoneNumber: yup
    //   .string()
    //   .required("Żeby się zarejestrować musisz podać numer telefonu")
    //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
    //   .min(9, "niepoprawny numer telefonu")
    //   .max(9, "niepoprawny numer telefonu"),
    name: yup.string(),
    city: yup.string().required(() => i18next.t("auth.validation.cityRequired", { ns: "admin" })),
    street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
    postalCode: yup
        .string()
        .required(() => i18next.t("auth.validation.postalCodeRequired", { ns: "admin" }))
        .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .min(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .max(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" })),
    bdo: yup
        .string()
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.bdoFormat", { ns: "admin" })),
    taxNumber: yup
        .string()
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.nipFormat", { ns: "admin" }))
        .min(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" }))
        .max(10, () => i18next.t("auth.validation.nipFormat", { ns: "admin" })),
    regon: yup
        .string()
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.regonFormat", { ns: "admin" }))
        .min(9, () => i18next.t("auth.validation.regonInvalid", { ns: "admin" }))
        .max(14, () => i18next.t("auth.validation.regonInvalid", { ns: "admin" })),
    // accept: yup
    //   .boolean()
    //   .oneOf([true], "W celu rejestracji musiz zakceptować regulamin"),
    multiDepartment: yup.boolean().oneOf([true, false]),
});

export const validationSchemaCompanyBasicInfo = yup.object().shape({
    postalCode: yup
        .string()
        .required(() => i18next.t("auth.validation.postalCodeRequiredCompanyBasicInfo", { ns: "admin" }))
        .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" }))
        .min(6, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" }))
        .max(6, () => i18next.t("auth.validation.postalCodeFormatCompanyBasicInfo", { ns: "admin" })),
    city: yup
        .string()
        .required(() => i18next.t("auth.validation.cityRequiredCompanyBasicInfo", { ns: "admin" })),
    street: yup.string().required(() => i18next.t("auth.validation.streetRequiredCompanyBasicInfo", { ns: "admin" })),
});

export const validationSchemaNonPolishCompanyBasicInfo = yup.object().shape({
    postalCode: yup
        .string()
        .required(() => i18next.t("auth.validation.postalCodeRequiredCompanyBasicInfo", { ns: "admin" })),
    city: yup
        .string()
        .required(() => i18next.t("auth.validation.cityRequiredCompanyBasicInfo", { ns: "admin" })),
    street: yup.string()
        .required(() => i18next.t("auth.validation.streetRequiredCompanyBasicInfo", { ns: "admin" })),
});

export const validationSchemaNotPolishCompany = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
        .max(50),
    name: yup.string(),
    city: yup.string().required(() => i18next.t("auth.validation.cityRequired", { ns: "admin" })),
    street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
    postalCode: yup.string().required(() => i18next.t("auth.validation.postalCodeRequiredCompanyBasicInfo", { ns: "admin" })),
    bdo: yup.string(),
    regon: yup.string()
})


export const validationSchemaDepartment = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
        .max(50),
    // phoneNumber: yup
    //   .string()
    //   .required("Żeby się zarejestrować musisz podać numer telefonu")
    //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
    //   .min(9, "niepoprawny numer telefonu")
    //   .max(9, "niepoprawny numer telefonu"),
    city: yup
        .string()
        .required(() => i18next.t("auth.validation.cityRequiredDepartment", { ns: "admin" })),
    street: yup.string().required(() => i18next.t("auth.validation.streetRequired", { ns: "admin" })),
    postalCode: yup
        .string()
        .required(() => i18next.t("auth.validation.postalCodeRequiredDepartment", { ns: "admin" }))
        .matches(/^[0-9, -]+$/, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .min(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" }))
        .max(6, () => i18next.t("auth.validation.postalCodeFormat", { ns: "admin" })),
    accept: yup
        .boolean()
        .oneOf([true], () => i18next.t("auth.validation.acceptTerms", { ns: "admin" })),
});

export const validationSchemaUser = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequired", { ns: "admin" }))
        .max(50),
    // phoneNumber: yup
    //   .string()
    //   .required("Żeby się zarejestrować musisz podać numer telefonu")
    //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
    //   .min(9, "niepoprawny numer telefonu")
    //   .max(9, "niepoprawny numer telefonu"),
    department: yup
        .string()
        .required(() => i18next.t("auth.validation.departmentRequired", { ns: "admin" })),
});

export const validationSchemaUserShort = yup.object().shape({
    email: yup
        .string()
        .email(() => i18next.t("auth.validation.emailInvalid", { ns: "admin" }))
        .required(() => i18next.t("auth.validation.emailRequiredUserShort", { ns: "admin" }))
        .max(50),
    // phoneNumber: yup
    //   .string()
    //   .required("Żeby się zarejestrować musisz podać numer telefonu")
    //   .matches(/^[0-9]+$/, "niepoprawny numer telefonu")
    //   .min(9, "niepoprawny numer telefonu")
    //   .max(9, "niepoprawny numer telefonu"),
});

export const validationSchemaNip = yup.object().shape({
    nip: yup
        .string()
        .required(() => i18next.t("auth.validation.nipRequired", { ns: "admin" }))
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.nipInvalidFormat", { ns: "admin" }))
        .min(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" }))
        .max(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" })),
});

export const validationSchemaNipNotRequired = yup.object().shape({
    nip: yup
        .string()
        .matches(/^[0-9]+$/, () => i18next.t("auth.validation.nipInvalidFormat", { ns: "admin" }))
        .min(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" }))
        .max(10, () => i18next.t("auth.validation.nipInvalid", { ns: "admin" })),
});